// AB-Modul: visueller Feld-Mapping-Editor (Welle 2 "UI-Paritaet", Agent FE-3).
// Praefix ab.map. — Key-fuer-Key-Paritaet mit abMap.en.js ist Pflicht (RULES).
const abMap = {
  // ---- Rahmen / Einstieg ----
  'ab.map.title': 'Feld-Mapping',
  'ab.map.subtitle': 'Pro Feld festlegen, woher der Wert kommt',
  'ab.map.adminOnlyTitle': 'Nur für Administratoren',
  'ab.map.adminOnlyHint': 'Der visuelle Feld-Mapping-Editor ist Administratoren vorbehalten (Vorschau/Speichern sind serverseitig geschützt).',
  'ab.map.pickDocTitle': 'Testdokument wählen',
  'ab.map.pickDocHint': 'Wähle ein Dokument, gegen das das Regelset getestet werden soll.',
  'ab.map.pickDocPlaceholder': 'Dokument wählen…',
  'ab.map.pickDocConfirm': 'Weiter',
  'ab.map.pickDocLoading': 'Dokumente werden geladen…',
  'ab.map.pickDocEmpty': 'Keine Dokumente vorhanden.',
  'ab.map.testDocLabel': 'Testdokument',
  'ab.map.switchDoc': 'Testdokument wechseln',
  'ab.map.existingLoadedMsg': 'Bestehendes Regelset „{supplier}" v{version} geladen — Speichern legt eine neue Version an.',
  'ab.map.newRulesetHint': 'Kein Regelset für dieses Dokument hinterlegt — leeres Formular.',
  'ab.map.unsupportedBanner': 'Dieses Regelset nutzt erweiterte Funktionen, die der visuelle Editor nicht abbilden kann. Bitte im Tab JSON (Experten-Modus) bearbeiten.',
  'ab.map.loadError': 'Regelset/Dokument konnte nicht geladen werden',

  // ---- Tabs ----
  'ab.map.tab.supplier': 'Lieferant',
  'ab.map.tab.positions': 'Positionen',
  'ab.map.tab.fields': 'Felder',
  'ab.map.tab.json': 'JSON',

  // ---- Tab Lieferant ----
  'ab.map.supplierIdLabel': 'Lieferant-ID',
  'ab.map.supplierIdPlaceholder': 'z. B. xometry',
  'ab.map.supplierNameLabel': 'Name',
  'ab.map.supplierNamePlaceholder': 'Klarname',
  'ab.map.detectionLabel': 'Erkennung',
  'ab.map.detectionHint': 'Eindeutige, stabile Textbausteine, die in jeder AB dieses Lieferanten vorkommen (z. B. Domain, feste Überschrift).',
  'ab.map.detectionPlaceholder': 'Textbaustein + Enter',
  'ab.map.unsupportedIdentityHint': 'Dieses Regelset wird im Tab JSON (Experten-Modus) bearbeitet; Lieferant-Angaben hier nur zur Info.',

  // ---- Tab Positionen ----
  'ab.map.strategyLabel': 'Strategie',
  'ab.map.strategy.column_rows': 'Spalten (Koordinaten — im PDF markieren)',
  'ab.map.strategy.blocks': 'Positionsblöcke (Text-Muster)',
  'ab.map.strategyHintColumns': 'Positionen sind Tabellenzeilen; Felder kommen aus x-Spalten (im PDF markieren).',
  'ab.map.strategyHintBlocks': 'Jede Position ist ein Textblock (per Start-Muster erkannt); Felder werden per Regex aus dem Blocktext gelesen.',
  'ab.map.tableTitle': 'Positions-Tabelle',
  'ab.map.rowAnchorPick': 'Positionsspalte (Anker) wählen',
  'ab.map.rowAnchorHint': 'die Spalte mit den Positionsnummern',
  'ab.map.rowAnchorPatternLabel': 'Anker-Muster',
  'ab.map.allPagesLabel': 'Tabelle läuft über mehrere Seiten (alle Seiten verarbeiten)',
  'ab.map.rowEndLabel': 'Tabellenende',
  'ab.map.rowEndNone': 'keins (bis Seitenende)',
  'ab.map.rowEndPick': 'Wort wählen',
  'ab.map.rowEndRemove': 'entfernen',
  'ab.map.rowEndHint': 'Optional. Nur ein Wort wählen, das unterhalb aller Werte steht (z. B. „Nettobetrag"). Nie die Währung/„Preis".',
  'ab.map.bandPadLabel': 'Band-Polsterung (px)',
  'ab.map.pageLabel': 'Seite',
  'ab.map.blocksTitle': 'Positionsblöcke',
  'ab.map.startPatternLabel': 'Start-Muster (Positionsbeginn, Gruppe 1 = Positionsnr.)',
  'ab.map.requirePatternLabel': 'Bedingung je Block (optional)',
  'ab.map.requirePatternPlaceholder': 'z. B. Kundenbestellnr:',
  'ab.map.blocksHint': 'Ein Block reicht von einem Start-Muster bis zum nächsten. „Bedingung" muss im Block vorkommen, sonst wird er übersprungen.',
  'ab.map.deliveryTitle': 'Lieferung (Termin + Menge)',
  'ab.map.deliveryHint': 'EEIND und MENGE werden gepaart aus der Datums-/Mengenliste unter dem Anker gelesen. Dazu bei EEIND und MENGE im Tab „Felder" den Erfassungsort „aus Lieferung" wählen.',
  'ab.map.deliveryAnchorLabel': 'Anker',
  'ab.map.deliveryAnchorPlaceholder': 'z. B. Wunschliefertermin',
  'ab.map.deliveryPairIndexLabel': 'Paar-Index (welche Liefer-Zeile)',
  'ab.map.deliveryAdvanced': 'Erweitert (Muster überschreiben)',
  'ab.map.deliveryDatePatternLabel': 'Datum-Muster',
  'ab.map.deliveryNumPatternLabel': 'Mengen-Muster',
  'ab.map.deliveryStopPrefixLabel': 'Stop-Präfix',
  'ab.map.patternDefaultPlaceholder': '(Engine-Default)',
  'ab.map.rowSkipTitle': 'Gelieferte Positionen überspringen',
  'ab.map.rowSkipSubtitle': 'optional (row_skip)',
  'ab.map.rowSkipPlaceholder': 'Marker-Regex + Enter (z. B. ausgeliefert)',
  'ab.map.rowSkipHint': 'Positionen, deren Zeilen-/Blocktext einen dieser Regex-Marker enthält, werden NICHT extrahiert.',
  'ab.map.yearPatternLabel': 'Jahr-Quelle (Muster)',

  // ---- Tab Felder ----
  'ab.map.fieldsTitle': 'Felder',
  'ab.map.fieldsHint': 'Feld-Karte aufklappen zum Bearbeiten — die Quelle wird links im PDF hervorgehoben.',
  'ab.map.scopeLabel': 'Erfassungsort',
  'ab.map.scope.off': 'nicht erfassen',
  'ab.map.scope.header': 'Kopf (ganzes Dokument)',
  'ab.map.scope.lineColumn': 'Positionsspalte',
  'ab.map.scope.lineBlock': 'Positionsblock (Text-Muster)',
  'ab.map.scope.delivery': 'aus Lieferung (Anker)',
  'ab.map.headerMethodLabel': 'Erfassung',
  'ab.map.headerMethod.box': 'Bereich auf PDF markieren',
  'ab.map.headerMethod.regex': 'Per Text-Muster',
  'ab.map.headerMethod.presence': 'Fester Wert',
  'ab.map.headerBoxPick': 'Bereich markieren (Wort anklicken)',
  'ab.map.headerBoxValue': 'Seite {page}, x {x0}–{x1}',
  'ab.map.headerRegexLabel': 'Muster',
  'ab.map.headerRegexPlaceholder': 'z. B. Nr\\.\\s*(\\d+)',
  'ab.map.headerGroupLabel': 'Gruppe',
  'ab.map.headerPresenceLabel': 'Wert wenn vorhanden',
  'ab.map.headerPresencePlaceholder': 'EUR',
  'ab.map.lineSourceLabel': 'Quelle',
  'ab.map.lineSource.extract': 'Aus dem PDF lesen (Spalte/Text)',
  'ab.map.lineSource.sequence': 'Laufende Nummer (10/20/30 …)',
  'ab.map.sequenceHint': 'Pos-Nr. wird gezählt (Dokument führt keine eigene Position).',
  'ab.map.sequenceStartLabel': 'Start',
  'ab.map.sequenceStepLabel': 'Schritt',
  'ab.map.formatLabel': 'Format',
  'ab.map.columnPick': 'Spalte wählen (Wort anklicken)',
  'ab.map.columnNone': 'noch keine Spalte',
  'ab.map.columnValue': 'x {min}–{max}',
  'ab.map.unitPick': 'PE-Spalte wählen (Wort anklicken)',
  'ab.map.decimalsLabel': 'Dezimalstellen',
  'ab.map.blockPatternLabel': 'Muster',
  'ab.map.blockPatternPlaceholder': 'Label:\\s*(\\S+)',
  'ab.map.blockGroupLabel': 'Gruppe',
  'ab.map.blockPpuPatternLabel': 'Muster (Preis + PE)',
  'ab.map.blockPpuPriceGroupLabel': 'Preis-Gr.',
  'ab.map.blockPpuUnitGroupLabel': 'PE-Gr.',
  'ab.map.blockPpuCodeGroupLabel': 'Code-Gr.',
  'ab.map.patternPickHint': 'Wort im PDF anklicken übernimmt den Text als Muster-Vorschlag (escaped); mehrere Klicks hängen an.',
  'ab.map.recognizedValue': '✓ {value}',
  'ab.map.recognizedValueMore': '✓ {value} (+{n})',
  'ab.map.recognizedEmpty': 'leer',
  'ab.map.activePickChip': 'Aktiv: {target} — jetzt links im PDF anklicken.',
  'ab.map.activePickCancel': 'Abbrechen',
  'ab.map.pickTarget.rowAnchor': 'Positionsspalte (Anker)',
  'ab.map.pickTarget.rowEnd': 'Tabellenende-Wort',
  'ab.map.pickTarget.headerBox': '{field} – Kopf-Bereich',
  'ab.map.pickTarget.headerRegex': '{field} – Text-Muster',
  'ab.map.pickTarget.headerPresence': '{field} – fester Wert',
  'ab.map.pickTarget.column': '{field} – Spalte',
  'ab.map.pickTarget.unit': '{field} – PE-Spalte',
  'ab.map.pickTarget.pattern': '{field} – Text-Muster',

  // ---- describeField() (rulesetModel.js) ----
  'ab.map.describe.off': 'wird nicht erfasst',
  'ab.map.describe.delivery': 'aus Lieferungs-Anker (Termin + Menge, gepaart)',
  'ab.map.describe.headerBox': 'Kopf: Bereich auf Seite {page} markiert',
  'ab.map.describe.headerBoxMissing': 'Kopf: Bereich noch nicht markiert',
  'ab.map.describe.headerPresence': 'Kopf: fester Wert „{value}", wenn vorhanden',
  'ab.map.describe.headerRegex': 'Kopf: per Text-Muster',
  'ab.map.describe.headerRegexMissing': 'Kopf: Text-Muster fehlt',
  'ab.map.describe.sequence': 'laufende Nummer {start}, +{step} je Position',
  'ab.map.describe.blockPpu': 'Block: Preis ÷ Einheit (Text-Muster)',
  'ab.map.describe.blockPpuMissing': 'Block: Preis-/PE-Muster fehlt',
  'ab.map.describe.columnPpu': 'Positionsspalte: Preis ÷ Einheit (PE)',
  'ab.map.describe.columnPpuMissing': 'Positionsspalte: Preis-/PE-Spalte wählen',
  'ab.map.describe.blockPeCode': 'Block: Preis je PE-Code (÷10^Code)',
  'ab.map.describe.blockPeCodeMissing': 'Block: Preis-/Code-Muster fehlt',
  'ab.map.describe.blockLabel': 'Block: Text-Muster (Gruppe {group}), {format}',
  'ab.map.describe.blockLabelMissing': 'Block: Text-Muster fehlt',
  'ab.map.describe.column': 'Positionsspalte: Spalte x {min}–{max}, {format}',
  'ab.map.describe.columnMissing': 'Positionsspalte: Spalte wählen, {format}',

  // ---- Formate (Dropdown-Labels) ----
  'ab.map.format.text': 'Text',
  'ab.map.format.decimal_de': 'Zahl (deutsch: 1.234,56)',
  'ab.map.format.decimal_us': 'Zahl (englisch: 1,234.56)',
  'ab.map.format.date_dmy': 'Datum TT.MM.JJJJ',
  'ab.map.format.date_isoweek_monday': 'Kalenderwoche KW/JJ im Text',
  'ab.map.format.date_mon_dmy': 'Datum TT-Mon-JJ (engl. Monat)',
  'ab.map.format.isoweek_week_column': 'Kalenderwoche (Spalte) → Montag',
  'ab.map.format.price_per_unit': 'Preis pro Einheit',
  'ab.map.format.price_per_pe_code': 'Preis je PE-Code (÷10^Code)',
  'ab.map.format.clean': 'Text bereinigt (Soft-Hyphen/nbsp)',

  // ---- Tab JSON ----
  'ab.map.jsonExpertTitle': 'Experten-Modus (JSON)',
  'ab.map.jsonReadOnlyHint': 'Schreibgeschützt — wird aus dem Formular erzeugt.',
  'ab.map.jsonUnsupportedHint': 'Dieses Regelset kann nur hier bearbeitet werden (Quelle der Wahrheit).',
  'ab.map.jsonInvalid': 'Ungültiges JSON: {error}',

  // ---- Aktionen ----
  'ab.map.aiSuggestButton': 'KI-Vorschlag',
  'ab.map.aiSuggestRunning': 'KI denkt…',
  'ab.map.aiSuggestStarting': 'KI-Vorschlag wird gestartet…',
  'ab.map.aiSuggestAdminOnly': 'KI-Vorschlag ist Administratoren vorbehalten.',
  'ab.map.aiSuggestNotConfigured': 'KI-Vorschlag ist nicht konfiguriert (LLM nicht verfügbar).',
  'ab.map.aiSuggestAlreadyRunning': 'Für dieses Dokument läuft bereits ein KI-Vorschlag-Job.',
  'ab.map.aiSuggestTimeout': 'KI-Vorschlag hat das Zeitlimit überschritten.',
  'ab.map.aiSuggestFailed': 'KI-Vorschlag fehlgeschlagen',
  'ab.map.aiSuggestBanner': 'KI-Vorschlag ({model}): {lineCount} Position(en), erkannt: {supplier}. Bitte Felder prüfen, dann „Speichern & aktivieren" — oder „KI-Vorschlag verwerfen".',
  'ab.map.aiSuggestBannerNoMatch': 'KI-Vorschlag ({model}): {lineCount} Position(en), kein Lieferant erkannt. Bitte Felder prüfen, dann „Speichern & aktivieren" — oder „KI-Vorschlag verwerfen".',
  'ab.map.aiSuggestWarnings': 'Hinweise: {warnings}',
  'ab.map.aiSuggestDiscard': 'KI-Vorschlag verwerfen',
  'ab.map.aiSuggestDiscardedMsg': 'KI-Vorschlag verworfen.',
  'ab.map.previewButton': 'Vorschau',
  'ab.map.previewRunning': 'Vorschau läuft…',
  'ab.map.previewResultTitle': 'Vorschau — {lineCount} Zeile(n), erkannt: {supplier}',
  'ab.map.previewMatchedNo': 'nein',
  'ab.map.previewPosHeader': 'Pos',
  'ab.map.previewEmptyHint': 'Noch keine Vorschau — Testdokument wählen und auf „Vorschau" klicken.',
  'ab.map.previewError': 'Vorschau fehlgeschlagen',
  'ab.map.saveActivateButton': 'Speichern & aktivieren',
  'ab.map.saveActivateRunning': 'Speichert & verarbeitet…',
  'ab.map.saveDraftButton': 'Als Entwurf speichern',
  'ab.map.saveDraftRunning': 'Speichert…',
  'ab.map.saveSupplierIdRequired': 'Bitte eine Lieferant-ID angeben.',
  'ab.map.saveActivatedMsg': 'Gespeichert als v{version}, aktiviert und Dokument neu verarbeitet → {status} ({lineCount} Position(en)).',
  'ab.map.saveActivatedMsgNoDoc': 'Gespeichert als v{version} und aktiviert.',
  'ab.map.saveDraftMsg': 'Als Entwurf (v{version}) gespeichert — noch nicht aktiv.',
  'ab.map.reprocessFailedHint': 'Regelset gespeichert, Neuverarbeitung des Testdokuments ist fehlgeschlagen: {error}',

  // ---- Einstieg aus der Regelset-Verwaltung ----
  'ab.map.openEditorButton': 'Im Mapping-Editor bearbeiten',
};
export default abMap;
